<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div>
        <a-range-picker
          v-model="dateRange"
          :allowClear="false"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          style="width:200px"
          v-tooltip="$t('writeOff.stockInDate')"
          @change="fetchData()"
        />
      </div>
      <div class=" ts-flex ts-space-x-3">
        <select
          class="form-control"
          style="width:200px"
          v-model="status"
          @change="fetchData()"
        >
          <option :value="0">Pendding</option>
          <option :value="1">Confirmed</option>
        </select>
        <ts-input
          v-model="search"
          v-tooltip="$t('writeOff.search')"
          :placeholder="$t('search')"
          style="width: 250px;"
          class="inline-block"
        />
      </div>
    </div>
    <div class="overflow-auto ts-mt-3">
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">
            {{ record.branch.branch_name_en }}
          </td>
          <td class="ts-whitespace-no-wrap ts-text-center">
            {{ record.write_off_date }}
          </td>
          <td class="ts-whitespace-no-wrap ts-text-center">
            {{ record.write_off_number }}
          </td>
          <td class="ts-whitespace-no-wrap ts-text-center">
            {{
              record.ref_stock_in ? record.ref_stock_in.stock_in_number : null
            }}
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.write_off_reason }}
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.location.location_name_en }}
          </td>
          <td class="ts-text-center">
            <span class="badge badge-primary" v-if="record.is_confirm"
              >Confirmed</span
            >
            <span class="badge badge-info" v-else>Pendding</span>
          </td>
          <td class="ts-whitespace-no-wrap">
            {{
              record.confirmed_by
                ? record.confirmed_by.employee
                  ? record.confirmed_by.employee.employee_name_en
                  : ''
                : ''
            }}
          </td>
          <td class="ts-text-center ts-whitespace-no-wrap">
            {{ record.confirmed_date }}
          </td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('view')"
              class="text-primary"
              @click.prevent="onView(record)"
            >
              <i class="fas fa-eye"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </div>
    <div class="d-flex justify-content-end p-15">
      <ts-pagination v-model="pagination" @navigate="fetchData">
      </ts-pagination>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'writeOffList',
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.$store.state.stock.writeOffConfirm.dateRange = [
      moment()
        .startOf('M')
        .format('DD-MM-YYYY'),
      moment()
        .endOf('M')
        .format('DD-MM-YYYY')
    ]
    this.fetchData()
  },
  computed: {
    ...mapState('stock/writeOffConfirm', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stock.writeOffConfirm.search
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_SEARCH', newValue)
        this.$store.commit('stock/writeOffConfirm/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get () {
        return this.$store.state.stock.writeOffConfirm.is_confirm
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_STATUS', newValue)
      }
    },
    dateRange: {
      get () {
        return this.$store.state.stock.writeOffConfirm.dateRange
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_DATE_RANGE', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('writeOff.branch'), style: 'width:10%' },
        {
          name: this.$t('writeOff.date'),
          style: 'text-align:center; width:8%'
        },
        {
          name: this.$t('writeOff.writeOffNumber'),
          style: 'text-align:center; width:8%'
        },
        {
          name: this.$t('writeOff.referenceStockIn'),
          style: 'text-align:center; width:8%'
        },
        { name: this.$t('writeOff.reason') },
        { name: this.$t('writeOff.warehouse'), style: 'width:8%' },
        {
          name: this.$t('writeOff.status'),
          style: 'text-align:center; width:5%'
        },
        {
          name: this.$t('writeOff.confirmedBy'),
          style: 'width:7%'
        },
        {
          name: this.$t('writeOff.confirmedDate'),
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:2%'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/writeOffConfirm/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onView (record) {
      this.$store.commit('stock/writeOffConfirm/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-confirm-write-off',
        params: { id: record.write_off_id }
      })
    },
    branchFilter (value) {
      this.$store.commit('stock/writeOffConfirm/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  }
}
</script>
